export default __webpack_public_path__ + "static/media/form_bg.1c708967.jpg";